//flow
import DimensionsTablePage from "./DimensionsTablePage";
export { DimensionsTablePage };
